import React from "react";
import { Grid, Typography, Container, Avatar, CardMedia } from "@material-ui/core";
import { Images } from "salvatores";
import { ArrowBack, CameraAlt } from "@material-ui/icons";
import { CustomAppBar, CustomButton } from "../../../shared";
import { styleSheet } from "../../../assets/theme";
import { AddressProofFrame } from "../../../assets/images";
import { getContent } from "../../../utils/helper";
import { supportedLanguageMapping } from "../../language/constants";
import {
   proofLabelMapping,
   proofRetakeMapping,
   proofCaptureMapping,
   proofSubmitMapping,
   proofCaptureBacksideMapping,
   PROOF_KEYS,
   PROOF_TYPE,
} from "../../../utils/constant";

const AddressProof = ({
   goBack,
   goToScreen,
   language,
   languageJSON,
   captureImage,
   step,
   submit,
   selectedAddressProofOption,
   saveAddressProof,
   addressProofList,
   handleChange,
   addressProofFrontSide,
   addressProofBackSide,
   idProofFrontSide,
   idProofBackSide,
   submitIdAsAddressProof,
   idProof,
   isCameraOn,
}) => {
   return (
      <div>
         <CustomAppBar
            title={getContent(languageJSON, "title_address_proof")}
            leftButton={<CustomButton variant="text" handleChange={goBack} label={<ArrowBack />} />}
            rightButton={
               <CustomButton
                  variant="text"
                  color="primary"
                  handleChange={() => goToScreen("language", { to: "addressProof" })}
                  label={supportedLanguageMapping[language]}
               />
            }
         />
         <Container style={{ height: "100vh", overflow: "auto", padding: "0px 0px 150px 0px" }}>
            {step === 1 ? (
               [PROOF_TYPE.PAN].indexOf(idProof) === -1 ? (
                  <Container>
                     <Grid
                        container
                        justify="center"
                        spacing={4}
                        style={{
                           maxHeight: !selectedAddressProofOption ? "100vh" : "85vh",
                           overflow: "scroll",
                           paddingBottom: selectedAddressProofOption && !isCameraOn ? "100px" : "0px",
                        }}
                     >
                        <Grid item xs={idProofBackSide ? 6 : 10}>
                           <Avatar
                              variant="square"
                              src={idProofFrontSide}
                              style={{ width: "100%", height: "30vh", objectFit: "contain" }}
                           />
                        </Grid>
                        {idProofBackSide ? (
                           <Grid item xs={6}>
                              <Avatar
                                 variant="square"
                                 src={idProofBackSide}
                                 style={{ width: "100%", height: "30vh", objectFit: "contain" }}
                              />
                           </Grid>
                        ) : null}
                        <Grid item xs={11}>
                           <CustomButton
                              size="large"
                              variant="contained"
                              style={{ textAlign: "center", width: "100%" }}
                              color="primary"
                              label={
                                 <Typography variant="button">
                                    {getContent(languageJSON, "action_submit_for_address_proof")}
                                 </Typography>
                              }
                              handleChange={submitIdAsAddressProof}
                           />
                        </Grid>
                        <Grid item xs={11}>
                           <Typography>{getContent(languageJSON, "subtitle_select_address_proof")}</Typography>
                        </Grid>
                        {addressProofList.map((item, index) => (
                           <Grid key={index} item xs={6} md={3}>
                              <CardMedia
                                 style={{ height: "15vh", width: "100%", backgroundSize: "contain" }}
                                 image={item.image}
                                 onClick={() => {
                                    handleChange("selectedAddressProofOption", item);
                                    saveAddressProof(item.value);
                                 }}
                              >
                                 <Grid container justify="center" alignItems="center" style={{ height: "100%" }}>
                                    <Grid
                                       item
                                       xs={11}
                                       style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                          alignItems: "center",
                                       }}
                                    >
                                       <CameraAlt
                                          style={{
                                             color:
                                                selectedAddressProofOption.value === item.value
                                                   ? styleSheet.palette.primary.main
                                                   : "#fff",
                                             width: 40,
                                             height: 40,
                                          }}
                                       />
                                       <Typography
                                          component="p"
                                          style={{
                                             color:
                                                selectedAddressProofOption.value === item.value
                                                   ? styleSheet.palette.primary.main
                                                   : "#fff",
                                          }}
                                       >
                                          {item.label}
                                       </Typography>
                                    </Grid>
                                 </Grid>
                              </CardMedia>
                           </Grid>
                        ))}
                     </Grid>
                  </Container>
               ) : (
                  <Container>
                     <Grid container justify="center" spacing={4} style={{ maxHeight: "85vh", overflow: "scroll" }}>
                        <Grid item xs={11}>
                           <Typography>{getContent(languageJSON, "subtitle_select_address_proof")}</Typography>
                        </Grid>
                        {addressProofList.map((item, index) => (
                           <Grid key={index} item xs={6} md={3}>
                              <CardMedia
                                 style={{ height: "15vh", width: "100%", backgroundSize: "contain" }}
                                 image={item.image}
                                 onClick={() => {
                                    handleChange("selectedAddressProofOption", item);
                                    saveAddressProof(item.value);
                                 }}
                              >
                                 <Grid container justify="center" alignItems="center" style={{ height: "100%" }}>
                                    <Grid
                                       item
                                       xs={11}
                                       style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                          alignItems: "center",
                                       }}
                                    >
                                       <CameraAlt
                                          style={{
                                             color:
                                                selectedAddressProofOption.value === item.value
                                                   ? styleSheet.palette.primary.main
                                                   : "#fff",
                                             width: 40,
                                             height: 40,
                                          }}
                                       />
                                       <Typography
                                          component="p"
                                          style={{
                                             color:
                                                selectedAddressProofOption.value === item.value
                                                   ? styleSheet.palette.primary.main
                                                   : "#fff",
                                          }}
                                       >
                                          {item.label}
                                       </Typography>
                                    </Grid>
                                 </Grid>
                              </CardMedia>
                           </Grid>
                        ))}
                     </Grid>
                  </Container>
               )
            ) : null}
            {step === 2 ? (
               <Container>
                  <Grid container justify="center" spacing={4} style={{ maxHeight: "85vh", overflow: "scroll" }}>
                     {addressProofFrontSide ? (
                        <Grid item xs={addressProofBackSide ? 6 : 10}>
                           <Avatar
                              variant="square"
                              src={addressProofFrontSide}
                              style={{ width: "100%", height: "40vh", objectFit: "contain" }}
                           />
                           <div style={{ margin: "5%" }}>
                              <Images
                                 frameHeight={600}
                                 title={getContent(
                                    languageJSON,
                                    proofRetakeMapping[selectedAddressProofOption.value] || PROOF_KEYS.RETAKE_DL
                                 )}
                                 subtitle={getContent(languageJSON, "label_front_side")}
                                 frame={AddressProofFrame}
                                 constraints={{
                                    audio: false,
                                    video: {
                                       facingMode: "environment",
                                    },
                                 }}
                                 cameraStateChange={(value) => {}}
                                 content={
                                    <CustomButton
                                       size="large"
                                       variant="contained"
                                       style={{ textAlign: "center", width: "100%" }}
                                       color="secondary"
                                       label={
                                          <Grid container alignItems="center" justify="center">
                                             <CameraAlt style={{ marginRight: 5 }} />
                                             <Typography style={{ fontSize: 12 }}>
                                                {getContent(
                                                   languageJSON,
                                                   proofRetakeMapping[selectedAddressProofOption.value] ||
                                                      PROOF_KEYS.RETAKE_DL
                                                )}
                                             </Typography>
                                          </Grid>
                                       }
                                    />
                                 }
                                 captureImage={(image) => captureImage("addressProofFrontSide", image)}
                              />
                           </div>
                        </Grid>
                     ) : null}
                     {addressProofBackSide ? (
                        <Grid item xs={6}>
                           <Avatar
                              variant="square"
                              src={addressProofBackSide}
                              style={{ width: "100%", height: "40vh", objectFit: "contain" }}
                           />
                           <div style={{ margin: "5%" }}>
                              <Images
                                 frameHeight={600}
                                 frame={AddressProofFrame}
                                 title={getContent(
                                    languageJSON,
                                    proofRetakeMapping[selectedAddressProofOption.value] || PROOF_KEYS.RETAKE_DL
                                 )}
                                 subtitle={getContent(languageJSON, "label_backside")}
                                 constraints={{
                                    audio: false,
                                    video: {
                                       facingMode: "environment",
                                    },
                                 }}
                                 cameraStateChange={(value) => {}}
                                 content={
                                    <CustomButton
                                       size="large"
                                       variant="contained"
                                       style={{ textAlign: "center", width: "100%" }}
                                       color="secondary"
                                       label={
                                          <Grid container alignItems="center" justify="center">
                                             <CameraAlt style={{ marginRight: 5 }} />
                                             <Typography style={{ fontSize: 12 }}>
                                                {getContent(languageJSON, "action_retake_back_side")}
                                             </Typography>
                                          </Grid>
                                       }
                                    />
                                 }
                                 captureImage={(image) => captureImage("addressProofBackSide", image)}
                              />
                           </div>
                        </Grid>
                     ) : null}
                  </Grid>
               </Container>
            ) : null}
            {step === 1 && selectedAddressProofOption ? (
               <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={{
                     padding: "15px",
                     position: !isCameraOn ? "absolute" : "",
                     bottom: 0,
                     left: 0,
                     backgroundColor: "#f7fdfd",
                  }}
               >
                  <Grid item xs={11}>
                     <Images
                        frameHeight={600}
                        frame={AddressProofFrame}
                        title={getContent(
                           languageJSON,
                           proofLabelMapping[selectedAddressProofOption.value] || PROOF_KEYS.LABEL_DL
                        )}
                        subtitle={getContent(languageJSON, "label_front_side")}
                        constraints={{
                           audio: false,
                           video: {
                              facingMode: "environment",
                           },
                        }}
                        cameraStateChange={(value) => handleChange("isCameraOn", value)}
                        content={
                           <CustomButton
                              size="large"
                              variant="contained"
                              style={{ textAlign: "center", width: "100%" }}
                              color="primary"
                              label={
                                 <Grid container alignItems="center" justify="center">
                                    <CameraAlt style={{ marginRight: 5 }} />
                                    <Typography style={{ fontSize: 12 }}>
                                       {getContent(
                                          languageJSON,
                                          proofCaptureMapping[selectedAddressProofOption.value] || PROOF_KEYS.CAPTURE_DL
                                       )}
                                    </Typography>
                                 </Grid>
                              }
                           />
                        }
                        captureImage={(image) => captureImage("addressProofFrontSide", image)}
                     />
                  </Grid>
               </Grid>
            ) : null}
            {step === 2 && ([PROOF_TYPE.OTHER].includes(selectedAddressProofOption.value) || addressProofBackSide) ? (
               <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={{
                     padding: "15px",
                     position: "absolute",
                     bottom: 0,
                     left: 0,
                     backgroundColor: "#f7fdfd",
                     zIndex: 5,
                  }}
               >
                  <Grid item xs={11}>
                     <CustomButton
                        size="large"
                        variant="contained"
                        style={{ textAlign: "center", width: "100%" }}
                        color="primary"
                        label={
                           <Typography variant="button">
                              {getContent(
                                 languageJSON,
                                 proofSubmitMapping[selectedAddressProofOption.value] || PROOF_KEYS.SUBMIT_DL
                              )}
                           </Typography>
                        }
                        handleChange={submit}
                     />
                  </Grid>
               </Grid>
            ) : null}
            {step === 2 && !addressProofBackSide ? (
               <Grid container justify="center" alignItems="center">
                  {[PROOF_TYPE.AADHAAR].indexOf(selectedAddressProofOption.value) > -1 && !addressProofBackSide ? (
                     <Grid item xs={11} style={{ padding: "2%" }}>
                        <Typography>{getContent(languageJSON, "text_capture_back_side")}</Typography>
                     </Grid>
                  ) : null}
                  <Grid item xs={11} style={{ padding: "2%" }}>
                     <Images
                        frameHeight={600}
                        frame={AddressProofFrame}
                        title={getContent(
                           languageJSON,
                           proofLabelMapping[selectedAddressProofOption.value] || PROOF_KEYS.LABEL_DL
                        )}
                        subtitle={getContent(languageJSON, "label_backside")}
                        constraints={{
                           audio: false,
                           video: {
                              facingMode: "environment",
                           },
                        }}
                        cameraStateChange={(value) => handleChange("isCameraOn", value)}
                        content={
                           <CustomButton
                              size="large"
                              variant="outlined"
                              style={{ textAlign: "center", width: "100%" }}
                              color="primary"
                              label={
                                 <Grid container alignItems="center" justify="center">
                                    <CameraAlt style={{ marginRight: 5 }} />
                                    <Typography style={{ fontSize: 12 }}>
                                       {getContent(
                                          languageJSON,
                                          proofCaptureBacksideMapping[selectedAddressProofOption.value] ||
                                             PROOF_KEYS.CAPTURE_BACKSIDE_DL
                                       )}
                                    </Typography>
                                 </Grid>
                              }
                           />
                        }
                        captureImage={(image) => captureImage("addressProofBackSide", image)}
                     />
                  </Grid>
               </Grid>
            ) : null}
         </Container>
      </div>
   );
};

export default AddressProof;
